/* @flow */

import * as React from 'react';

import { Button, Footer } from '@sonyged/ext-proc';

import { Customer } from './domain/customer';
import { type FinishedRound, Round } from './domain/Round';
import { Stars } from './Stars';
import { ingredientName } from './domain/pizza';
import AutoScaleContainer from './AutoScaleContainer';
import PizzaContainer from './PizzaContainer';
import PizzaCustomerIcon from './icons/PizzaCustomerIcon';

type Props = {
  onNext: FinishedRound => void,
  round: FinishedRound,
  fromStats?: boolean,
};

const Review = ({ customer, rating }: { customer: Customer, rating: number }) => {
  return (
    <div className="proc-result-rate">
      <PizzaCustomerIcon customer={customer} talking={true} onRequestToTalk={() => {}} />
      <div className="proc-result-rate-star">
        <Stars satisfactionScore={rating} />
      </div>
    </div>
  );
};

class PizzaResultView extends React.Component<Props> {
  renderResultSale() {
    const round = this.props.round;
    return (
      <table className="proc-table">
        <thead>
          <tr>
            <th className={'left-aligned'}>もらった お金</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="proc-result-sale">
                <div className="proc-result-sale-info">
                  <span className="proc-huge-font">{Round.sale(round)}</span>
                  <span className="proc-medium-font"> 円</span>
                  <div className="ingredients-container proc-small-font secondary100-color">
                    {[round.pizza.crust, round.pizza.sauce].concat(round.pizza.toppings).map((ingredient, i) => (
                      <div key={i}>{ingredientName(ingredient)}</div>
                    ))}
                  </div>
                </div>
                <div className="proc-result-sale-pizza">
                  <AutoScaleContainer preferedHeight={600} preferedWidth={1080} preferedMinWidth={1080}>
                    <PizzaContainer pizza={round.pizza} />
                  </AutoScaleContainer>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderRatings() {
    const customerRatings = Round.ratings(this.props.round);
    return (
      <table className="proc-table">
        <thead>
          <tr>
            <th className={'left-aligned'}>ちゅうもんと まんぞくど</th>
          </tr>
        </thead>
        <tbody>
          {customerRatings.map((customerRating, i) => (
            <tr key={i}>
              <td>
                <Review {...customerRating} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className={`pizza-inner-view pizza-result-view tertiary100-bg-color`}>
        <div className={`proc-contents padding`}>
          <div className="proc-outer">
            <div className="proc-inner">
              <div className="content">
                {this.renderResultSale()}
                {this.renderRatings()}
              </div>
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </div>
    );
  }

  renderFooter() {
    return <Footer.normal className="white-bg-color">{this.renderNextButton()}</Footer.normal>;
  }

  renderNextButton() {
    const { fromStats = false } = this.props;
    if (fromStats) {
      return <Button.normal onClick={this.onNextClick.bind(this)}>もどる</Button.normal>;
    }
    return <Button.attention onClick={this.onNextClick.bind(this)}>つぎへ</Button.attention>;
  }

  onNextClick() {
    this.props.onNext(this.props.round);
  }
}

export default PizzaResultView;
